import { render } from "./Top10ListItem.vue?vue&type=template&id=0b232896&scoped=true"
import script from "./Top10ListItem.vue?vue&type=script&lang=js"
export * from "./Top10ListItem.vue?vue&type=script&lang=js"

import "./Top10ListItem.vue?vue&type=style&index=0&id=0b232896&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b232896"]])

export default __exports__